export default __webpack_public_path__ + "static/media/arrow-white.c4ddf7fa.svg";